// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fr-program-qualifier-checkbox[data-v-30bb330d]{display:flex;flex-direction:row;align-content:flex-start;flex-wrap:wrap}.fr-program-qualifier-checkbox label[data-v-30bb330d]{font-size:.7rem;text-transform:none;font-weight:400}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
